// SimpleButton.js
import React from "react";
import PropTypes from "prop-types";
import styles from "./SimpleButton.module.css"; // Import the button's CSS module

const SimpleButton = ({ label, onClick, variant = "primary" }) => {
  const buttonClass = styles[`outline-button-outline-${variant}`];

  return (
    <button
      className={`${styles["outline-button"]} ${buttonClass}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

// PropTypes to validate prop types
SimpleButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary", "success"]), // Default button styles
};

export default SimpleButton;
